import React from "react";
import ManageTrustedContactsComponent from "../../components/ManageTrustedContactsComponent/ManageTrustedContactsComponent";

export default function TrustedContactMobilePage(props: any) {
  return (
    <>
      <ManageTrustedContactsComponent
        personId={Number(props.match.params.id)}
        userFirstName={props.match.params.username} />
    </>
  );
}
